import { FC } from 'react'
import { StyledNavigation, NavigationButton, ButtonContentWrapper } from './Navigation.style'
import { MainNavigationType } from '../../../utils/constants/Navigation'

export type SpacingType = 'default' | 'medium' | 'xlarge'

interface INavigation {
  data?: MainNavigationType
  handler?: (arg: string) => void
  pathname?: string
  showIcon?: boolean
  spacing?: SpacingType
}

const Navigation: FC<INavigation> = ({ data, handler, showIcon, spacing, pathname }) => {
  if (!Array.isArray(data) || data?.length === 0) {
    return null
  }

  const onClick = (path: string) => handler?.(path)

  return (
    <StyledNavigation>
      {data.map((nav, index) => {
        if (nav?.disabled) {
          return null
        }

        return (
          <NavigationButton
            active={nav.path === pathname}
            onClick={() => onClick(nav.path || '')}
            key={index}
            spacing={spacing}
          >
            <ButtonContentWrapper>
              {showIcon && nav.icon && nav.icon}
              {nav.text}
            </ButtonContentWrapper>
          </NavigationButton>
        )
      })}
    </StyledNavigation>
  )
}

Navigation.defaultProps = {
  data: [],
  handler: () => null,
  showIcon: true,
  spacing: 'xlarge',
}

export default Navigation
